<script>
	import axios from "axios";
	import LoginRegister	from "./LoginRegister.svelte";
	import AccountSelected	from "./AccountSelected.svelte";
	import LeaveCash	from "./LeaveCash.svelte";
	import LeaveCashShare	from "./LeaveCashShare.svelte";
	import LeaveCashPickup	from "./LeaveCashPickup.svelte";
	import Transfer	from "./Transfer.svelte";
	import Charts from "./Charts.svelte";
	import { onMount } from 'svelte';
	import Merge from 'lodash.merge';
	const resetState = () =>{ return {isLoggedIn: false, loadingAccounts: true, accounts: [], synched: false, selectedAccount: null, cash: {} } }
	let state = resetState()
	let msgs = []
let sessionExpireTimer = null
var actions = {}
let active = false
const canDebug = process.env == 'production' ? false : true
var isDebugging = false
state = resetState(); 

	$: if(state.sessionExpires) {
		// reset sessionExpireTimer and restart it with difference between now and sessionExpire
			if (sessionExpireTimer) {clearTimeout(sessionExpireTimer)}
			let diff = new Date(state.sessionExpires).getTime() - new Date().getTime()
			sessionExpireTimer = setTimeout(() => { console.log('session expired');state = resetState();  remount() }, diff)
	}

	$: if(state.doing=='account' && !state.selectedAccount) { pushState("welcome"); }

	actions.doClaimCash = function (opt = {}) {
		callApi('post', `/api/accounts/${opt.acct}`, {do: 'claimCash', tx:opt.tx })
		.then( () => {
			state.cash.collected = true
		} )
		.catch( (err) => {
			console.log('error claiming cash', err)
		})
	}

	const doingStates = {
	'welcome': { entering: loadWelcome, title: 'M$'},
	'cash': {	entering: cashPickupDetailsLoad, title: 'Pickup Cash'},
	'share': {	entering: leaveCashShare, title:	'Share Cash'	},
	'account': { title: 'Account' },
	'leave': { entering: LeaveCashBegin, title: 'Leave Cash' },
}

function loadWelcome() {
	actions.doLoadAccounts()
}

actions.doSetState	= function (opt = {}) {
		pushState(opt)
	}

	/*  This function is the routing mechanism that 
	** watches and maintains the URL hash and
	** triggers the different states of the app, allowing
	** state changes to transition from one to another
	** This function, if passed with a "do" property,
	** will change the current state.doing and the URL
	**
	** We can use this function in two ways. We can
	** 1) Call it and trigger leave and enter functions
	**	2) Forget the leave and enter functions and do the
	** nescessary logic somewhere else. Just use this to 
	** update the URL routing
	*/
function pushState(opts = {}, needsRefresh = false) {
	state.msgs = []
	let curUrl = new URL(window.location.href).hash || ''
	let updateUrl = false
	if(typeof opts == 'string') opts = {do: opts}
	if( curUrl.startsWith('#app')) { // app is active, so continue
		if(!active) toggleActive();  // make sure app is visible

		/* Here we check to see: Was a new state requested? 
		** If not, we refresh the detected state that's in the URL
		*/
		let doWhat, param
		if(opts.do) {
			doWhat = opts.do
			param = opts.param
			needsRefresh = true
		} else { // no parameter was passed so we refresh the state
		let matches = curUrl.match(/#app\/(?<do>[^\/]+)\/{0,1}(?<param>[^\/]*)/)?.groups || {}
	 doWhat = matches?.do, param = matches?.param
		if(!doWhat || !doingStates?.[doWhat]) { doWhat = 'welcome'; needsRefresh	= true; }
	}
			
	if(doWhat != state.doing || param !=	state.param || needsRefresh) {
		updateUrl	= true
		if(!needsRefresh) doingStates?.[state.doing]?.leaving?.(param)
		state.doing = doWhat
		state.param = param
		doingStates?.[doWhat]?.entering?.(param) 
		document.title = `${doingStates?.[doWhat]?.title || 'M$'} - Metric DC`
	}
	if(updateUrl) { // it's not just a refresh, it's a state change, so update the hash in the URL
		let hash = '#app/' + doWhat
		if(param) hash += '/' + param
		history.pushState({}, null, hash)
		}
}	else { 	if(active) toggleActive(); }
}

	function leaveCashShare(txId) {
		//pushState('share')
		callApi('get', `/api/cash/${txId}`)
		.catch(	(err) => {
			console.log(err) })
	}

function cashPickupDetailsLoad(txId) {
	// load the cash pickup details
	state.cash = {}
	actions.doLoadAccounts().then(	() => {
	callApi('get', `/api/cash/${txId}`)
	.then( (res) => {
	})
	.catch(	(err) => {
		console.log(err)
	})
})
}

actions.doCloseApp = function () {
	// close the app
	leaveApp(); 
	toggleMenu('close');
}
actions.doLogin = function (opts) {
	return callApi(opts.method, opts.url, opts.body)
	.then( () => {
		if(state.isLoggedIn) {
		actions.doGetUser().then(	() => {
			refreshState()
		})
	}
	})
}

function toggleActive() {
		active = !active
		document.querySelector("#app").classList.toggle("d-inactive")
		document.querySelector("main.content").classList.toggle("d-inactive")

}

function remount()	{
	actions.doGetUser()
		.catch(err => {
			console.log(err)
		})
		.then( () => {	refreshState()})
}

function refreshState() {
	pushState({}, true)
}

actions.doLoadAccounts = function()	{
	state.loadingAccounts	= true
	return callApi('get', '/api/accounts')
	.then( () => { state.loadingAccounts = false;})
}

	function doAction (message) {
		let deets =	message.detail
try{actions[deets.do](deets)}catch(err){console.log(err)}	
}

 function callApi(method, url, body = {}) {
		state.synched = false
		return axios[method](url, body)
		.then(response => {
			let mx = response.data;
			if (mx.download) {
				var link = document.querySelector("#download-link");
				link.setAttribute("href", mx.download);
				link.setAttribute("download", mx.filename || 'data.txt');
				link.click();
				delete mx.download, mx.filename
			}
			Merge(state, mx || {} )
			})
		.catch( (err) => {
			console.log(err)
			throw	err
		})
		.finally(	() => {
			state.synched	= true
			setTimeout( () => state=state, 1)
		})
	}

	onMount(async () => {
		addEventListener('hashchange', () => { if(!state.active) refreshState() });
 remount()
	});

	actions.doGetUser= function() {
		return callApi('get', '/api/user')
	}

	actions.doSelectAccount = function (opt) {
		selectAccount(opt.account	)
	}

	function createAccount() {
		let buttonElement = this
		this.disabled = true
		let txt = [buttonElement.innerText, 'wait a second...']
		buttonElement.innerText = txt[1]
		callApi('get', '/api/next-transaction-id')
		.then ( async function () {
			await new Promise(r => setTimeout(r, 2000));
			callApi('post', '/api/account-create', {trxid: state.trxid})
			.then ( function () {
				callApi('get','api/accounts')
			})
		})
		.finally( function () { buttonElement.innerText = txt[0]; buttonElement.disabled = false } )
	}

	function selectAccount(account) {
		if(account == null) {state.selectedAccount = null; return pushState('welcome'); }
		if(account && !account.download) account.trxs = []
		state.selectedAccount = account
		state.selectedAccount.loading = true
		pushState('account');
		callApi('get', `/api/accounts/${state.selectedAccount.id}?num=${state.selectedAccount.num??''}&start=${state.selectedAccount.start??''}&end=${state.selectedAccount.end??''}&download=${state.selectedAccount.download??''}`)
		.then(	() => {		state.selectedAccount.loading = false; state.selectedAccount.download = false})
		.catch (	err => {		pushState('welcome'); console.log(err); state.selectedAccount.download = false; state.selectedAccount=null})
	}

	actions.doLeaveCashBegin = function (opt) {
		pushState("leave")
	}

	function LeaveCashBegin() {
		if(!state.selectedAccount || !state.isLoggedIn) { pushState('welcome') }
	}

	actions.doShare = function	(opt) {
		pushState({do:'share',	param:opt.txId})
	}

	actions.doLeaveCashFinalize	= function (opt) {
		callApi('post', '/api/accounts/' + opt.acct, {...opt, do:'leaveCash'})
		.then ( () => { 		pushState({do:'share',param: state.cash.id}) }) 
		.catch (	err => {console.log(err); refreshState()})
		//.finally( () => {		document.querySelector('#leaveCash').classList.toggle('disabled')})
	}
function toggleMenu(intention='') {
	if(intention == 'close') {
		try{
		document.querySelector('#menu').classList.remove('slide-in'); 
		document.querySelector('#app').classList.remove('block-page')
		} catch(err) {console.log(err)}
	} else if(intention == 'open') {	
		try{
		document.querySelector('#menu').classList.add('slide-in');
		document.querySelector('#app').classList.add('block-page')
		} catch(err) {console.log(err)}
	} else {
		document.querySelector('#menu').classList.toggle('slide-in'); 
	document.querySelector('#app').classList.toggle('block-page')
	}
}

function logOut() {
	callApi('get', '/api/logout')
	.catch( err => {console.log(err)})
	.finally( () => { history.pushState({},'','#app'); state = resetState(); remount() })

}

function leaveApp() {
	toggleActive()
	history.pushState({}, null, ' ') 
}

</script>


<header id="minihead" class="{!active ? 'd-inactive' : 'd-active'}">
	<div class="logo-svg" on:click={ () => actions.doSelectAccount({account: null } )}></div>
	<div class="menu" on:click = { toggleMenu }></div>

</header>

<main class="pt-3 app {!active ? 'd-inactive' : 'd-active'}" style="position:relative;">
<!--	<div id="synching" class={state.synched ? 'd-none' : ''}
style="position:absolute; top:0; left:0; width:100%; height:100%; background-color:inherit; z-index:1000; ">
	<p style="font-size:large; font-weight:bold;">Synching up...</p>
</div> -->
	{#if (!state.isLoggedIn)}
	{#if state.doing == "cash"} 
	<p class="notice">Hey! You gotta login to pickup cash...</p>
	{/if}
		<LoginRegister on:action={doAction}></LoginRegister>
		{/if}


		{#if (state.isLoggedIn)}

		{#if state.doing == "welcome"}
		<h1 style="text-overflow:ellipsis;overflow:hidden;">Welcome {state.email}</h1>

		{#if state.loadingAccounts}
		<div>Loading accounts...</div>
		{:else}
		{#each state.accounts	as account}
		<div style="max-width:100vh;" class="selectable {account!=state.accounts[0] ? 'mt-1' : ''}"	on:click={() => {selectAccount(account)}}>
			{account.title || 'Account created on ' + new Date(account.acct.ts).toLocaleDateString()}
			<p><b>M${new Intl.NumberFormat().format(account.avail)}</b> available balance</p>
			</div>
		{/each}
		{#if !state.accounts.length}
		<p>No accounts are set up yet. Create one?</p>
		{/if}

		{#if state.accounts.length<100}
		<p><button on:click|preventDefault={createAccount}>Create account...</button></p>
		{/if}

		<Charts/>
		{/if}
		{/if}

	{/if}
	{#if state?.msgs && state.msgs.length}
	{#each state?.msgs as msg}
	<div class="message-box"><p class="notice">{msg}</p></div>
	<div>	</div>
{/each}
{/if}
{#if state.isLoggedIn}
	{#if state.doing=="account"}
	<AccountSelected account={state.selectedAccount} on:action={doAction} />
	{/if}

	{#if state.doing=="leave" && state.isLoggedIn && state.selectedAccount}
	<LeaveCash account={state.selectedAccount} on:action={doAction}  />
	{/if}

	{#if state.doing == "transfer" && state.selectedAccount}
	<Transfer accounts=state.accounts account={state.selectedAccount} on:action={doAction} />
	{/if}	
	
	{#if state.doing == "share"}
	<LeaveCashShare account={state.account} cash={state.cash} on:action={doAction} />
	{/if}	

	{#if state.doing == "cash"}
	<LeaveCashPickup accounts={state.accounts} cash={state.cash} on:action={doAction} />
	{/if}

{/if}

{#if isDebugging}
	<pre>{JSON.stringify(state,	null, 2)}</pre>
	{/if}
</main>

<aside id="menu" style="
position: fixed;
top: 0;
right: -400px;
max-width: 400px;
width:100%;
height: 100%;
background-color: #333;
color: #fff;
transition: right 0.5s ease-in-out;
">
<ul style="
				list-style-type: none;
				margin: 0;
				padding: 0;
">
<li style="
padding: 20px;
border-bottom: 1px solid #444;
text-align:right;
">
<button on:click={toggleMenu}>Close X</button>
</li><li style="
padding: 20px;
border-bottom: 1px solid #444;
">
<button on:click={() => {actions.doSelectAccount({account: null}); toggleMenu(); } }>Accounts</button>
</li><li style="
padding: 20px;
border-bottom: 1px solid #444;
">
Settings
</li>
{#if canDebug}
<li style=" padding: 20px; border-bottom: 1px solid #444; ">
<button on:click={ () => {isDebugging = !isDebugging} }>Toggle Debugging</button>
</li>	
{/if}
<li style="
padding: 20px;
border-bottom: 1px solid #444;

">
<button on:click={ () => {logOut(); toggleMenu();} }>Log Out</button>
</li>				<li style="
padding: 20px;

">
<button on:click={ () => {actions.doCloseApp();} }>Leave App</button>
</li>
</ul>
{#if process.env!='production'}<p>Mode = {process.env}</p>{/if}
</aside>
<a id="download-link">download</a>


<style>
	</style>